import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';

@Component({
    selector: 'homepage-add-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class HomepageAdd implements OnInit {
  public form: FormGroup;
  public image;
  public type;
  public catTitle;
  public catId;
  public isFakeCat;
  public selectOptions = [];

  constructor(
    protected dialogRef: MatDialogRef<HomepageAdd>,
    @Inject(MAT_DIALOG_DATA) public config
  ) {}

  ngOnInit() {
    const formBuilder = new FormBuilder();
    const { CategoryId, HomepageOffers, CategoryTitle } = this.config;
    this.catTitle = CategoryTitle;
    this.catId = CategoryId;
    this.isFakeCat =
      this.catTitle === 'Future Homepage Products' ||
      this.catTitle === 'Future Main Carousels';

    this.form = formBuilder.group({
      listingId: [null, [Validators.required]],
    });

    if (this.isFakeCat) {
      this.form.addControl(
        'start_date',
        formBuilder.control(null, [Validators.required])
      );
      this.form.addControl(
        'listing_to_replace',
        formBuilder.control(null, [Validators.required])
      );
    }

    if (this.catTitle === 'Future Homepage Products') {
      this.createSelectBox(
        'Homepage Products',
        'Future Homepage Products',
        HomepageOffers
      );
    }

    if (this.catTitle === 'Future Main Carousels') {
      this.createSelectBox(
        'Main Carousels',
        'Future Main Carousels',
        HomepageOffers
      );
    }
  }

  createSelectBox(catTitle, futureCatTitle, HomepageOffers) {
    const ind = HomepageOffers.findIndex((item) => item.title === catTitle);
    const index = HomepageOffers.findIndex(
      (item) => item.title === futureCatTitle
    );

    this.selectOptions = HomepageOffers[ind].items.filter(
      (item) =>
        !HomepageOffers[index].items.some(
          (i) => i.listing_to_replace === item.id
        )
    );
  }

  onSubmit() {
    this.form.disable();
    let form = this.form.getRawValue();
    form = {...form, start_date: moment(form.start_date).format('YYYY-MM-DD')};
    let catId = this.catId;

    this.config.HomepageDataSource.save(form, catId).then(() =>
      this.dialogRef.close()
    );
  }
}
